import { Link } from "react-router-dom";

/**
 * Strata · by Friedman Group brand mark.
 * Wordmark in tall condensed Oswald with "by Friedman Group" tucked beneath at the
 * bottom-right of the wordmark block. Left-justified.
 */
export default function Brand({ size = "md", color = "navy", asLink = true, className = "" }) {
  const presets = {
    sm: { word: "text-[22px] leading-none", tag: "text-[8px] tracking-[0.32em] -mt-1" },
    md: { word: "text-[28px] leading-none", tag: "text-[9px] tracking-[0.32em] -mt-1" },
    lg: { word: "text-[56px] sm:text-[64px] leading-[0.9]", tag: "text-xs tracking-[0.32em] -mt-1.5" },
  };
  const s = presets[size] || presets.md;

  const colors = {
    navy: { word: "text-white", tag: "text-white/70" },
    dark: { word: "text-slate-900", tag: "text-slate-500" },
  };
  const c = colors[color] || colors.navy;

  const content = (
    <span className={`inline-flex flex-col items-start ${className}`}>
      <span
        className={`font-light ${s.word} ${c.word}`}
        style={{ fontFamily: "'Oswald', 'Manrope', sans-serif", letterSpacing: "-0.005em" }}
      >
        Strata
      </span>
      <span className={`${s.tag} ${c.tag} font-medium uppercase`}>
        by Friedman Group
      </span>
    </span>
  );

  if (!asLink) return content;
  return <Link to="/dashboard" className="inline-block">{content}</Link>;
}
